import Image from 'next/image';

export const Video = ({
  src,
  alt,
  width,
  height,
  style,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  style?: React.CSSProperties;
}) => {
  return (
    <video
      width={width}
      height={height}
      autoPlay
      loop
      muted
      playsInline
      style={style}
      controlsList='nodownload nofullscreen noremoteplayback'
      disablePictureInPicture
      controls={false}
    >
      <source src={src} type='video/mp4' />
      <source src={src.replace('.mp4', '.webm')} type='video/webm' />
      {/* Fallback for browsers that don't support video */}
      <Image
        src={src.replace('.mp4', '.png')}
        alt={alt}
        width={width}
        height={height}
        style={style}
      />
    </video>
  );
};
